// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Xo97","consentsList":"PatientConsents_consentsList__3xnGT","consentsListEmpty":"PatientConsents_consentsListEmpty__26f4B"};